import {
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
  Breadcrumb as ShadcnBreadcrumb,
} from '@components/ui/breadcrumb';
import { cn } from '@lib/utils';
import React from 'react';
import { useNavigate } from 'react-router-dom';

type BreadcrumbsProps = {
  className?: string;
  items: { href?: string; label: string }[];
};

export const Breadcrumbs: React.FC<BreadcrumbsProps> = (props) => {
  const { className, items } = props;

  const navigate = useNavigate();

  return (
    <ShadcnBreadcrumb className={cn(className)}>
      <BreadcrumbList>
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <BreadcrumbItem>
              <BreadcrumbLink
                onClick={() => item.href && navigate(item.href)}
                className={cn(
                  item.href ? 'cursor-pointer' : 'cursor-default',
                  'font-semibold text-sm text-[#3d2eff] hover:text-[#3d2eff]',
                )}
              >
                {item.label}
              </BreadcrumbLink>
            </BreadcrumbItem>
            {index < items.length - 1 && <BreadcrumbSeparator className="text-[#3d2eff]" />}
          </React.Fragment>
        ))}
      </BreadcrumbList>
    </ShadcnBreadcrumb>
  );
};
